import Vue from 'vue';
import Vuetify from 'vuetify';

Vue.use(Vuetify);

import ModalHome from "../pages/ModalHome.vue";

Vue.config.productionTip = false;
Vue.config.devtools = false;

if (document.getElementById("modal-home")) {
    new Vue({
        el: '#modal-home',
        components: {
            ModalHome
        },
        data: () => ({}),
        methods: {},
        vuetify: new Vuetify(),
    });
}